import { Util } from "@/utils/util";
import { Component } from "@angular/core";
import { CalendarOptions, EventInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { DiasFestivosService } from "@services/diasFestivos.service";
import { NgxSpinnerService } from "ngx-spinner";
import { DiasFestivosModel } from "@/store/diasFestivos.model";

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.scss"],
})
export class CalendarComponent {    
  constructor(
    private festivoService: DiasFestivosService,
    private spinner: NgxSpinnerService,
    private util: Util,
  ) {}

  ngOnInit(): void {
    this.cargarLista();
  }

  cargarLista(): void {
    this.spinner.show();

    this.festivoService.getAll().subscribe({
      next: (data: DiasFestivosModel[]) => {
        this.calendarOptions = {
          ...this.calendarOptions,
          events: this.mapFestivosToEvents(data),
        };
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.util.errorMessage("Error al cargar los días festivos");
      },
    });
  }

  private mapFestivosToEvents(festivos: DiasFestivosModel[]): EventInput[] {
    return festivos
      .filter((festivo) => !!festivo.fecha)
      .map((festivo) => ({
        title: String(festivo.descripcion || "Día festivo"),
        start: this.normalizeDate(festivo.fecha),
        allDay: true,
        extendedProps: {
          image: "assets/img/logo.png",
          description: String(festivo.descripcion || "Día festivo"),
        },
      }));
  }

  private normalizeDate(fecha: string | Date): string {
    if (fecha instanceof Date) {
      return fecha.toISOString().split("T")[0];
    }

    return fecha.split("T")[0];
  }

  calendarOptions: CalendarOptions = {
    initialView: "dayGridMonth",
    plugins: [dayGridPlugin],
    events: [],
    eventDidMount: (info) => {
      const description = info.event.extendedProps.description;

      if (description) {
        info.el.title = String(description);
      }
    },
    eventContent: (arg) => {
      const description = arg.event.extendedProps.description || arg.event.title;

      const wrapper = document.createElement("div");
      wrapper.style.display = "flex";
      wrapper.style.flexDirection = "column";
      wrapper.style.alignItems = "center";
      wrapper.style.gap = "2px";
      wrapper.style.width = "100%";

      if (arg.event.extendedProps.image) {
        const image = document.createElement("img");
        image.src = arg.event.extendedProps.image;
        image.style.width = "20px";
        image.style.height = "20px";
        image.style.objectFit = "contain";
        image.style.display = "block";
        wrapper.appendChild(image);
      }

      if (description) {
        const label = document.createElement("span");
        label.textContent = String(description);
        label.style.fontSize = "11px";
        label.style.fontWeight = "600";
        label.style.textAlign = "center";
        label.style.whiteSpace = "normal";
        label.style.lineHeight = "1.2";
        label.style.color = "#333";
        wrapper.appendChild(label);
      }

      return { domNodes: [wrapper] };
    },
  };
}
